import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

function ForgotPasswordDialogFooter({
  result, submit, close, isLoading,
}) {
  if (!result) {
    return (
      <div className="els-btn-group-right forgot-password-dialog__footer">
        <Button
          buttonConfig={{
            type: 'primary',
            size: 'sm',
            label: 'Send me a recovery email',
            e2eName: 'forgot-password-continue',
          }}
          iconConfig={{
            name: 'chevron-right',
            size: 'sm',
          }}
          disabled={isLoading}
          onClick={submit}
        />
      </div>
    );
  }
  return (
    <div className="els-btn-group-right forgot-password-dialog__footer">
      <Button
        buttonConfig={{
          type: 'primary',
          size: 'sm',
          label: 'OK, got it',
          e2eName: 'forgot-password-close',
        }}
        iconConfig={{
          name: 'chevron-right',
          size: 'sm',
        }}
        onClick={close}
      />
    </div>
  );
}

ForgotPasswordDialogFooter.propTypes = {
  result: PropTypes.string,
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default ForgotPasswordDialogFooter;
